export default __webpack_public_path__ + "static/media/s-pic-1.ae6ef61b.png";